import { createSlice } from "@reduxjs/toolkit";
const initialState={
  alerts:[]
}
export const AlertSlice = createSlice({
  name: "alert",
  initialState: initialState,
  reducers: {
    createAlert: (state,action) => {
      state.alerts.push({
        id: Math.floor(Math.random() * 100) + 1,
        message: action.payload.message,
        type: action.payload.type,
        heading: action.payload.heading,
      });
     
    },
    removeAlert:(state,action) => {
      state.alerts = state.alerts.filter(alert=>alert.id !== action.payload);
    }
  },
});

// Action creators are generated for each case reducer function
export const {createAlert, removeAlert} = AlertSlice.actions;

export default AlertSlice.reducer;


